// src/constants/besoinConstants.js
// Miroir exact des référentiels définis côté backend (models/Besoin.js)
// La traduction se fait uniquement côté front via les fichiers de langue (i18n)

export const STATES_IDS = [1, 2, 3, 4, 5, 6, 7]; // besoin.states.<gender>_1 à besoin.states.<gender>_7

// Les libellés d'états sont genrés dans les fichiers de langue :
// besoin.states.male_1 ... besoin.states.male_7 / besoin.states.female_1 ... besoin.states.female_7
export const GENDERS = ['male', 'female'];
export const DEFAULT_GENDER = 'male'; // fallback si le profil n'a pas de genre renseigné

export const normalizeGender = (gender) =>
  (GENDERS.includes(gender) ? gender : DEFAULT_GENDER);

// Retourne la clé i18n de l'état pour le genre donné
export const getStateKey = (stateId, gender) =>
  `besoin.states.${normalizeGender(gender)}_${stateId}`;

export const PERIOD_IDS = [1, 2, 3, 4, 5]; // 1=heure, 2=jour, 3=semaine, 4=mois, 5=annee

export const STATUS_IDS = [1, 2, 3, 4]; // 1=pas_integre, 2=mal_integre, 3=resistance, 4=integre

export const DEFAULT_STATUS = 1;

// Palette utilisée dans la sidebar (AppWrapper.js) pour les initiales du titre
const COLORS = ['#6F3F89', '#375A9C', '#029FB2', '#29A648', '#E0B614', '#DA5E20', '#C11D24'];

// Couleur associée à chaque état : ordre INVERSÉ de COLORS.
// state_1 -> dernière couleur (#C11D24), state_7 -> première couleur (#6F3F89)
export const STATE_COLORS = STATES_IDS.reduce((acc, id, idx) => {
  acc[id] = COLORS[COLORS.length - 1 - idx];
  return acc;
}, {});